import React, { useEffect, useState } from "react";
import { IFloatingFilterParams } from "ag-grid-community";
import { useDataTableContext } from "../shared/Context";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUp, faDown  } from '@fortawesome/pro-regular-svg-icons';

interface IDirectionFloatingFilterProps extends IFloatingFilterParams {
  defaultFilterValue?: string[];
  name?: string;
}

const CustomBooleanToggleFloatingFilter = (props: IDirectionFloatingFilterProps) => {
  const { floatingFilterValueMap } = useDataTableContext();
  const { parentFilterInstance, api, column, defaultFilterValue = [], name } = props;

  const colId = column.getColId();
  const floatingFilterValueMapKey = `${name}${colId}`;
  const initialValue = floatingFilterValueMap.current.get(floatingFilterValueMapKey) ?? defaultFilterValue[0] ?? "";
  const [selectedDirection, setSelectedDirection] = useState(initialValue);

    useEffect(() => {
        if (initialValue) {
        floatingFilterValueMap.current.set(floatingFilterValueMapKey, initialValue);
        parentFilterInstance((filterInstance) => {
            filterInstance.setModel({
            type: "equals",
            filter: initialValue,
            });
        });
        /* api.onFilterChanged(); */
        }
    }, []);

    const updateFilter = (direction: string) => {
        if (selectedDirection === direction) {
            setSelectedDirection("");
            floatingFilterValueMap.current.delete(floatingFilterValueMapKey); 
            parentFilterInstance((filter) => {
                filter.setModel(null);
                api.onFilterChanged();
            });
        } else {
            setSelectedDirection(direction);
            floatingFilterValueMap.current.set(floatingFilterValueMapKey, direction);
            parentFilterInstance((filter) => {
                filter.setModel({ type: "equals", filter: direction });
                api.onFilterChanged();
            });
        }
    };


    return (
        <div style={{ display: "flex", justifyContent: "center", gap: "2px", height: "24px" }}>
        <button
            className={`boolean-toggle-floating-filter up ${selectedDirection === "uplink" ? "selected" : ""}`}
            onClick={() => updateFilter("uplink")}
            title={`uplink`}
        >
            <FontAwesomeIcon icon={faUp} />
        </button>
        <button
            className={`boolean-toggle-floating-filter down ${selectedDirection === "downlink" ? "selected" : ""}`}
            onClick={() => updateFilter("downlink")}
            title={`downlink`}
        >
            <FontAwesomeIcon icon={faDown} />
        </button>
        </div>
    );
};

export default CustomBooleanToggleFloatingFilter;
